import { Card, Group, Select, Stack, Text, TextInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { CALENDAR_TYPES } from "../../../../constants/calendarConstants";
import { useCreateFormContext } from "../createFormContext";
import { COLORS } from "../../../../constants/colorConstants";
import { useLocalAuthorityContext } from "../../../../contexts/LocalAuthorityContext";
import { useMemo } from "react";
import { mapLocalAuthoritiesGroupedByRegion } from "../../../../utils/mappingUtils";
import { getPresetsForSingleDates } from "../../../../utils/datePickerPresetUtils";

export default function CreateFormSettingsCard() {
  return (
    <Card shadow="xs" p="md" radius="lg" mb="md" miw={520} withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
      <Stack>
        <NameInput />
        <TypeInput />
        <LocalAuthorityInput />
        <StartDateInput />
        <EndDateInput />
      </Stack>
    </Card>
  );
}

function NameInput() {
  const form = useCreateFormContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Name</Text>
      <TextInput radius="md" w={350} key={form.key("name")} {...form.getInputProps("name")} />
    </Group>
  );
}

function TypeInput() {
  const form = useCreateFormContext();

  return (
    <Group justify="space-between">
      <Text fw={700}>Type</Text>
      <Select
        allowDeselect={false}
        radius="md"
        checkIconPosition="right"
        w={250}
        comboboxProps={{ transitionProps: { transition: "pop", duration: 200 } }}
        rightSection={null}
        key={form.key("type")}
        {...form.getInputProps("type", { type: "select" })}
        data={[
          { label: CALENDAR_TYPES.EDUCATION.label, value: CALENDAR_TYPES.EDUCATION.id },
          { label: CALENDAR_TYPES.HOLIDAY.label, value: CALENDAR_TYPES.HOLIDAY.id },
        ]}
      />
    </Group>
  );
}

function LocalAuthorityInput() {
  const form = useCreateFormContext();
  const { dropdownFetch } = useLocalAuthorityContext();

  const localAuthorities = dropdownFetch?.data ?? [];
  const data = useMemo(() => {
    return mapLocalAuthoritiesGroupedByRegion(localAuthorities);
  }, [localAuthorities]);

  return (
    <Group justify="space-between">
      <Text fw={700}>Local Authority</Text>
      <Select
        searchable
        nothingFoundMessage="No results"
        radius="md"
        w={350}
        maxDropdownHeight={200}
        clearable
        checkIconPosition="right"
        comboboxProps={{ transitionProps: { transition: "pop", duration: 200 } }}
        rightSection={<></>}
        clearButtonProps={{
          c: COLORS.WHEAT,
          bg: COLORS.DARK_BROWN,
          radius: "xl",
          variant: "light",
        }}
        data={data}
        key={form.key("localAuthorityId")}
        {...form.getInputProps("localAuthorityId", { type: "select" })}
      />
    </Group>
  );
}

function StartDateInput() {
  const form = useCreateFormContext();
  const presets = getPresetsForSingleDates();

  return (
    <Group justify="space-between">
      <Text fw={700}>Start Date</Text>
      <DatePickerInput
        radius="md"
        w={250}
        dropdownType="modal"
        valueFormat="DD MMM YYYY"
        presets={presets}
        key={form.key("startDate")}
        {...form.getInputProps("startDate")}
      />
    </Group>
  );
}

function EndDateInput() {
  const form = useCreateFormContext();
  const presets = getPresetsForSingleDates();

  return (
    <Group justify="space-between">
      <Text fw={700}>End Date</Text>
      <DatePickerInput
        radius="md"
        w={250}
        dropdownType="modal"
        valueFormat="DD MMM YYYY"
        presets={presets}
        key={form.key("endDate")}
        {...form.getInputProps("endDate")}
      />
    </Group>
  );
}
